var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.4563 11.7642L54.7256 34.5883L60.4084 21.1224L85.4563 11.7642Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5129 11.7642L44.9966 34.8045L39.5917 21.1224L14.5129 11.7642Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3992 64.6704L66.2146 77.2098L83.7265 82.0278L88.7607 64.9484L74.3992 64.6704Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.27 64.9484L16.2734 82.0278L33.7853 77.2098L25.6007 64.6704L11.27 64.9484Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7968 43.4832L27.917 50.8648L45.3053 51.6369L44.6876 32.9514L32.7968 43.4832Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.172 43.4831L55.1268 32.7351L54.7253 51.6368L72.0828 50.8647L67.172 43.4831Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7852 77.2096L44.2243 72.1136L35.2059 65.0718L33.7852 77.2096Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7446 72.1136L66.2147 77.2096L64.7631 65.0718L55.7446 72.1136Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2147 77.2098L55.7446 72.1138L56.5785 78.9394L56.4859 81.8117L66.2147 77.2098Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7854 77.2098L43.5142 81.8117L43.4524 78.9394L44.2246 72.1138L33.7854 77.2098Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6686 60.5627L34.959 57.9993L41.1051 55.1887L43.6686 60.5627Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3005 60.5627L58.864 55.1887L65.041 57.9993L56.3005 60.5627Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7854 77.2098L35.2679 64.6704L25.6008 64.9484L33.7854 77.2098Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7322 64.6704L66.2147 77.2098L74.3992 64.9484L64.7322 64.6704Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.083 50.8647L54.7256 51.6369L56.3316 60.5627L58.8951 55.1887L65.0721 57.9992L72.083 50.8647Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.959 57.9992L41.1361 55.1887L43.6686 60.5627L45.3056 51.6369L27.9172 50.8647L34.959 57.9992Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9172 50.8647L35.2061 65.0719L34.959 57.9992L27.9172 50.8647Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.072 57.9992L64.7632 65.0719L72.083 50.8647L65.072 57.9992Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3056 51.637L43.6687 60.5628L45.7071 71.0946L46.1704 57.2272L45.3056 51.637Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7255 51.637L53.8916 57.1963L54.2622 71.0946L56.3315 60.5628L54.7255 51.637Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3315 60.5627L54.2622 71.0946L55.7447 72.1138L64.7631 65.072L65.072 57.9993L56.3315 60.5627Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.959 57.9993L35.2061 65.072L44.2245 72.1138L45.707 71.0946L43.6686 60.5627L34.959 57.9993Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.486 81.8118L56.5786 78.9395L55.8065 78.2601H44.1628L43.4524 78.9395L43.5142 81.8118L33.7854 77.21L37.1828 79.9896L44.0701 84.7768H55.8991L62.8174 79.9896L66.2148 77.21L56.486 81.8118Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7447 72.1137L54.2622 71.0945H45.707L44.2245 72.1137L43.4524 78.9393L44.1627 78.2598H55.8064L56.5786 78.9393L55.7447 72.1137Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7533 36.0707L89.3785 23.4696L85.4561 11.7642L55.7446 33.8161L67.1721 43.4832L83.325 48.2086L86.9077 44.0391L85.3635 42.9272L87.8343 40.6726L85.9194 39.1901L88.3902 37.3062L86.7533 36.0707Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6216 23.4696L13.2468 36.0707L11.579 37.3062L14.0498 39.1901L12.1658 40.6726L14.6366 42.9272L13.0924 44.0391L16.6442 48.2086L32.7971 43.4832L44.2246 33.8161L14.5131 11.7642L10.6216 23.4696Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3251 48.2088L67.1722 43.4834L72.083 50.8649L64.7632 65.0721L74.3993 64.9486H88.7609L83.3251 48.2088Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7969 43.4834L16.644 48.2088L11.27 64.9486H25.6007L35.206 65.0721L27.9171 50.8649L32.7969 43.4834Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7255 51.6371L55.7447 33.8163L60.4393 21.1226H39.5918L44.2246 33.8163L45.3055 51.6371L45.6762 57.2582L45.707 71.0947H54.2622L54.324 57.2582L54.7255 51.6371Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamask-icon.c28aed674ee50cc6771c809cc86023ca.svg";
export { ForwardRef as ReactComponent };